import { useQueryClient } from 'react-query'
import { QueryKey } from 'config/constants/queryKey'
import { getCraftsmanAddress } from 'utils/addressHelpers'
import { useCallback } from 'react'
import { useWeb3React } from '@web3-react/core'

const useInvalidateActualBoostFactor = (farmId, lpAddress) => {
  const queryClient = useQueryClient()
  const { account } = useWeb3React()

  const invalidatingActualBoostFactor = useCallback(() => {
    queryClient.invalidateQueries([QueryKey.TOKEN_BALANCE_QUERY, lpAddress, getCraftsmanAddress()])
    queryClient.invalidateQueries([QueryKey.CRAFTSMAN_USER_INFO, account, farmId])
    queryClient.invalidateQueries([QueryKey.GET_ACTUAL_ADJUST_SHARE, account, farmId])
    queryClient.invalidateQueries([QueryKey.HARVEST_BOOST_BY_PID, account, farmId])
    queryClient.invalidateQueries([QueryKey.WITHDRAW_BOOST_REWARD, account])
    queryClient.invalidateQueries([QueryKey.MY_MOLE_IDS_WITH_STAKED, account])
  }, [account, farmId, lpAddress, queryClient])

  return { onInvalidatingActualBoostFactor: invalidatingActualBoostFactor }
}

export default useInvalidateActualBoostFactor
